import { yupResolver } from "@hookform/resolvers/yup";
import Input from "components/Input";
import { showToast } from "components/Toaster";
import { Button } from "flowbite-react";

import React, { useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import httpClient from "services/network/httpClient";
import * as yup from "yup";

const schem = yup.object().shape({
  cropName: yup
    .string()
    .trim()
    .required("Crop name is required")
    .matches(
      /^[A-Za-z\s(),/]+$/,
      "Crop name should contain only letters, spaces, (), comma and /"
    )
});
interface AddProps {
  onClose: () => void;
  getData: () => void;
}
const AddCrops = ({ onClose, getData }: AddProps) => {
  const [loading, setLoading] = useState(false);
  const methods = useForm({
    resolver: yupResolver(schem),
  });

  const submit = (data: any) => {
    setLoading(true);
    httpClient
      .post("crop/create", data)
      .then((res: any) => {
        console.log("response :", res)
        if (res.success === true) {
          console.log("test:", res.success);
          showToast("Crop created successfully", "success");
        } else {
          showToast(res.error?.message || "Failed to create crop", "error");
        }
      })
      .catch((error) => {
        const errorMessage = error.response?.data?.message || error.message || "An error occurred";
        showToast(errorMessage, "error");
      })
      .finally(() => {
        setLoading(false);
        onClose();
        getData();
      });
  };
  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(submit)}>
        <Input
          name={"cropName"}
          label={"Crop Name"}
          placeholder="Enter Crop Name"
          required={true}
          onChange={(e) => {
            // Allow only letters and spaces in crop name
            e.target.value = e.target.value.replace(/[^A-Za-z\s(),/]/g, "");
          }}
          helperText="Only letters and spaces allowed"
        />
        <div className="mt-4 flex justify-end gap-2">
          <Button color="light" onClick={onClose} type="button">
            Cancel
          </Button>
          <Button type="submit" isProcessing={loading} disabled={loading}>
            {loading ? "Submitting..." : "Submit"}
          </Button>
        </div>
      </form>
    </FormProvider>
  );
};
export default AddCrops;
